// extracted by mini-css-extract-plugin
module.exports = {"giftProductTableCard":"styles_giftProductTableCard__3-kjq","productImage":"styles_productImage__34gth"};